<header class="header-container-wrapper">
    <div class="main-header">
        <div class="logo-wrapper">
          <picture>
          <source srcset="assets/images/logo-bajaj-capital.webp" type="image/webp">
          <img src="assets/images/logo-bajaj-capital.png" alt="BajajCapital">
        </picture>
        </div>
    </div>
  </header>